import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import PRICE_BOOST_LABEL from './price-boost-label.palette-schema.yaml';

registerTileSchema(PRICE_BOOST_LABEL);

export function generatePriceBoostLabel(TILE) {
    const {FONT} = TILE;

    return {
        container: {
            style: {
                ...resolveBackground(TILE.PRICE_BOOST_LABEL_CONTAINER_BG),
                borderRadius: TILE.PRICE_BOOST_LABEL_CONTAINER_BORDER_RADIUS,
            },
        },
        iconContainer: {
            style: {
                ...resolveBackground(TILE.PRICE_BOOST_LABEL_ICON_CONTAINER_BG),
                borderRadius: '50%',
                height: TILE.PRICE_BOOST_LABEL_ICON_CONTAINER_SIZE,
                width: TILE.PRICE_BOOST_LABEL_ICON_CONTAINER_SIZE,
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: 0,
            },
        },
        icon: {
            src: 'price-boost',
            style: {
                fill: TILE.PRICE_BOOST_LABEL_ICON_COLOR,
                minHeight: TILE.PRICE_BOOST_LABEL_ICON_SIZE,
                minWidth: TILE.PRICE_BOOST_LABEL_ICON_SIZE,
                width: TILE.PRICE_BOOST_LABEL_ICON_SIZE,
                height: TILE.PRICE_BOOST_LABEL_ICON_SIZE,
            },
        },
        label: {
            style: {
                textTransform: 'uppercase',
                fontSize: FONT.SIZE_SMALL,
                fontWeight: FONT.WEIGHT_SEMI_BOLD,
                ...TILE.PRICE_BOOST_LABEL_TEXT,
            },
        },
    };
}
